import ApiService from '@/plugins/apiService'
import { cloneDeep } from 'lodash-es'

export default {
  state: {
    users: []
  },

  mutations: {
    SET_USERS (state, users) {
      state.users = users
    },

    SET_USER(state, { id, userData }) {
      state.users = state.users.map(user => {
        if (user.id === id) {
          return userData
        }
        return user
      })
    },

    REMOVE_USER(state, id) {
      state.users = state.users.filter(user => user.id !== id)
    }
  },

  actions: {
    fetchUsers({ commit }) {
      return ApiService.getUsers()
        .then(({ data }) => {
          commit('SET_USERS', data)
        })
    },

    editUser({ dispatch }, userData) {
      return ApiService.editUser(userData)
        .then(() => {
          dispatch('fetchUsers')
        })
    },

    createUser({ dispatch }, userData) {
      return ApiService.createUser(userData)
        .then(() => {
          dispatch('fetchUsers')
        })
    },

    deleteUser({ commit }, id) {
      return ApiService.deleteUser(id)
        .then(() => {
          commit('REMOVE_USER', id)
        })
    }
  },

  getters: {
    getUserById: state => id => {
      // cloneDeep нужен, поскольку объект юзера используется в качестве model
      return cloneDeep(state.users.find(user => user.id === id))
    }
  }
}
